import React from 'react';
import { Card, Progress } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';

const RewardProgram = () => {
  const rewardLevels = [
    { 
      name: "Sponsors Gold", 
      value: 85, 
      color: "#F59E0B",
      totalSponsors: 24,
      targetValue: 100
    },
    { 
      name: "Sponsors Silver", 
      value: 65, 
      color: "#64748B",
      totalSponsors: 38,
      targetValue: 150
    },
    { 
      name: "Sponsors Bronze", 
      value: 45, 
      color: "#B45309",
      totalSponsors: 52,
      targetValue: 200
    },
  ];

  return (
    <Card
      title={
        <div className="flex items-center gap-2">
          <TrophyOutlined className="text-primary-500" />
          <span className="font-heading">Programme de récompenses</span>
        </div>
      }
      className="h-full"
    >
      <div className="space-y-6">
        {rewardLevels.map((level, index) => (
          <div key={index}>
            <div className="flex justify-between mb-2">
              <div>
                <span className="text-sm text-neutral-600">
                  {level.name}
                </span>
                <span className="text-xs text-neutral-400 block">
                  {level.totalSponsors} sponsors • Objectif: {level.targetValue}
                </span>
              </div>
              <span className="text-sm font-medium" style={{ color: level.color }}>
                {level.value}%
              </span>
            </div>
            <Progress 
              percent={level.value}
              strokeColor={level.color}
              trailColor="rgba(0,0,0,0.04)"
              showInfo={false}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default RewardProgram;
